import Message from "../../../../i18n/Message";
import NewWorkspaceLayout from "../../layout/NewWorkspaceLayout";
import { useParams } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import IntegrationTile from "../IntegrationTile";
import AddIntegrationDialog from "../AddIntegrationDialog";
import PlusIcon from "../../../../assets/icons/PlusIcon";
import backend from "../../../../backend/backend";
import Spinner from "../../../../assets/icons/Spinner";

import "./IntegrationListPage.scss";

const IntegrationListPage = () => {
  const { workspaceId } = useParams();
  const [showDialog, setShowDialog] = useState(false);
  const [integrations, setIntegrations] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadIntegrations = useCallback(() => {
    setLoading(true);
    backend
      .getIntegrations(workspaceId)
      .then((data) => {
        setIntegrations(data || []);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Failed to load integrations", err);
        setIntegrations([]);
        setLoading(false);
      });
  }, [workspaceId]);

  useEffect(() => {
    if (workspaceId) {
      loadIntegrations();
    }
  }, [workspaceId, loadIntegrations]);

  const handleDelete = (uid) => {
    setIntegrations((prev) => prev.filter((i) => i.uid !== uid));
  };

  const handleSuccess = () => {
    loadIntegrations();
  };

  return (
    <NewWorkspaceLayout contentPanelClassName="integrations_main">
      <div className="body_content card">
        <div className="content_header">
          <h1>
            <Message id="integrations_title" />
          </h1>
          <button
            className="btn bg-gradient-dark"
            type="button"
            onClick={() => setShowDialog(true)}
          >
            <PlusIcon color="#fff" strokeWidth="2" size="18" />
            <Message id="integration_add" />
          </button>
        </div>

        <div className="integrations_content">
          {loading && (
            <div className="loading_state">
              <Spinner size={40} />
            </div>
          )}

          {!loading && integrations.length === 0 && (
            <div className="empty_state">
              <p>
                <Message id="no_integrations_yet" />
              </p>
              <button
                className="btn bg-gradient-dark"
                type="button"
                onClick={() => setShowDialog(true)}
              >
                <PlusIcon color="#fff" strokeWidth="2" size="18" />
                <Message id="integration_add" />
              </button>
            </div>
          )}

          {!loading && integrations.length > 0 && (
            <div className="integrations_grid">
              {integrations.map((integration) => (
                <IntegrationTile
                  key={integration.uid}
                  integration={integration}
                  onDelete={handleDelete}
                />
              ))}
            </div>
          )}
        </div>
      </div>

      {showDialog && (
        <AddIntegrationDialog
          onClose={() => setShowDialog(false)}
          onSuccess={handleSuccess}
        />
      )}
    </NewWorkspaceLayout>
  );
};

export default IntegrationListPage;
